import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { Breadcrumbs, Skeleton } from '@mui/material';
import { BACK_BUTTON_STYLES } from '@/layouts/MainLayout/utils/constants';
import { useEntitiesList } from '@/providers/EntitiesListContextProvider/EntitiesListContext.hooks';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { useHeader } from '@/providers/HeaderContextProvider/HeaderContextProvider.hooks';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledTitleWithTooltipWrapper,
  StyledToolbarWrappingBackButton,
  StyledBackButton,
  StyledBackArrowIcon,
  StyledHeader,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';
import { StyledAnime } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/EntityHeader/EntityHeader.styled';
import { ERoutes } from '@/types/routes';

export const EntityHeader = () => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpointsCtx();
  const { entityName } = useParams();
  const { isEntitiesListLoading, getDisplayNameByEntityValue } = useEntitiesList();
  const { node, visible } = useHeader();

  const breadcrumbs = [
    <StyledAgioH1 key={0} noWrap color="customSecondary.primary.DEFAULT">
      {isEntitiesListLoading ? (
        <Skeleton variant="text" animation="wave" width="160px" />
      ) : (
        getDisplayNameByEntityValue(entityName || '')
      )}
    </StyledAgioH1>,
  ];

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledToolbarWrappingBackButton>
        <StyledBackButton
          onClick={() => navigate(`${ERoutes.DASHBOARD}`)}
          skipTypography
          disableRipple
          blockHoverBehavior
          sx={BACK_BUTTON_STYLES}
        >
          <StyledBackArrowIcon />
        </StyledBackButton>

        <StyledTitleWithTooltipWrapper>
          <Breadcrumbs
            separator="›"
            aria-label="breadcrumb"
            color="customSecondary.primary.DEFAULT"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </StyledTitleWithTooltipWrapper>

        <StyledAnime data-visible={visible}>{node}</StyledAnime>
      </StyledToolbarWrappingBackButton>
    </StyledHeader>
  );
};
